import { createStyles, makeStyles } from '@material-ui/core/styles';
export var useStyles = makeStyles(function (theme) { return createStyles({
    root: {
        '& > option': {
            color: theme.palette.text.primary,
        },
    },
}); });
//# sourceMappingURL=languageStyles.js.map